import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PageHead } from "@/components/PageHead";
import { Reveal } from "@/components/Reveal";
import { img, COLLECTION_LIST } from "@/lib/site";

export default function Collection() {
  return (
    <>
      <PageHead
        eyebrow="Our Collection"
        titleLines={["Materials,", "curated."]}
        intro="Four collections, one standard. Explore the timber, natural stone, custom carpet and marble we source and supply."
      />

      <section className="hairline" data-testid="collection-list">
        {COLLECTION_LIST.map((c, i) => (
          <Reveal key={c.slug}>
            <Link
              to={`/collections/${c.slug}`}
              data-testid={`collection-row-${c.slug}`}
              className="group grid grid-cols-1 items-stretch border-b hairline md:grid-cols-12"
            >
              <div className={`flex flex-col justify-center p-8 md:col-span-5 md:p-12 ${i % 2 ? "md:order-2 md:col-start-8" : ""}`}>
                <span className="eyebrow">{c.index}</span>
                <h2 className="mt-3 text-3xl font-light tracking-editorial md:text-4xl">{c.name}</h2>
                <p className="mt-2 text-sm text-muted-foreground">{c.tagline}</p>
                <span className="mt-6 inline-flex items-center gap-3 text-sm uppercase tracking-[0.16em]">
                  Explore
                  <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
                </span>
              </div>
              <div className={`overflow-hidden md:col-span-7 ${i % 2 ? "md:order-1 md:border-r hairline" : "md:border-l hairline"}`}>
                <motion.img
                  src={img(c.homeImage || c.banner || "/assets/logo.png", 1400)}
                  alt={c.name}
                  className="aspect-[4/3] w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105"
                />
              </div>
            </Link>
          </Reveal>
        ))}
      </section>

      <section className="edge py-24 text-center md:py-32" data-testid="collection-cta">
        <p className="mx-auto max-w-xl text-2xl font-light tracking-editorial md:text-3xl">
          Prefer to see the materials in person?
        </p>
        <Link
          to="/contact"
          data-testid="collection-contact-cta"
          className="mt-8 inline-block border-b border-foreground pb-1 text-sm uppercase tracking-[0.16em]"
        >
          Get in touch →
        </Link>
      </section>
    </>
  );
}
